import { Divider, Stack, Toolbar, Typography } from "@mui/material";
import { Notification } from "Components/Notification";
import { ContactInfo } from "Components/SharedComponents/ContactInfo";
import ThemeToggler from "Components/SharedComponents/ThemeToggler";
// To be replaced with svg once available
import { MobileOnlyStack } from "Components/Admin/AdminWrapper.styled";
import { ShLogo } from "Components/SharedComponents/ShLogo";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { DesktopOnlyStack } from "shared/SharedStyles/ShLayouts";
import { ShMuiLink } from "shared/SharedStyles/ShNavigation";
import { ShAppBar } from "shared/SharedStyles/ShSurfaces";
import { AppLoginOutlet } from "./AppLogin.styled";

export const AppLoginWrapper = () => {

    const pathName = useLocation()?.pathname?.split('/').pop() as 'login' | 'sign-up';
    const navigate = useNavigate();

    // get subdomain from url, if resources navigate to resources related pages.
    const subdomain = new URL(window.location.href)?.hostname?.split('.')[0] as 'resources' | string;

    useEffect(() => {
        if (subdomain === 'resources') {
            navigate('/resources');
        }
    }, [navigate, subdomain]);

    return (<>
        {/* Snackbar type Notifications component */}
        <Notification />
        <Stack height='100vh'>
            <ShAppBar position="sticky">
                <Toolbar>
                    <Stack width='100%' direction='row' justifyContent='space-between' alignItems='center'>
                        <ShLogo />
                        <Stack direction='row' alignItems='center'>
                            {/* Hiding sign in button in top nav if the user is already in login page */}
                            {pathName !== 'login' && <>
                                <DesktopOnlyStack flexDirection='row' alignItems='center' mr={2}>
                                    <Typography variant='body2' whiteSpace='nowrap'>
                                        Already have an account?
                                    </Typography>
                                    <ShMuiLink ml={1} onClick={() => navigate('/account/login')} variant='body2'
                                        underline='hover'>Sign In</ShMuiLink>
                                </DesktopOnlyStack>
                            </>}
                            <DesktopOnlyStack direction='row' columnGap={2}>
                                <ContactInfo showDivider dividerOrientation='vertical' />
                            </DesktopOnlyStack>
                            <ThemeToggler />
                        </Stack>
                    </Stack>
                </Toolbar>
            </ShAppBar>
            <AppLoginOutlet>
                <Outlet />
            </AppLoginOutlet>
            {/* Contact info */}
            <MobileOnlyStack padding={2} rowGap={1}>
                <Divider />
                <ContactInfo />
            </MobileOnlyStack>
        </Stack>
    </>)
}